import { useState } from "react";
import { CheckCircle2, Loader2, RefreshCw, ShieldCheck, Sparkles } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg, fmtDateTime } from "../../lib/api";

export default function CrmSettings({ ent, onChanged }) {
  const [busy, setBusy] = useState(false);
  const renew = async () => {
    setBusy(true);
    try { await api.post("/store-admin/crm/entitlement/activate-test"); toast.success("CRM renewed (test mode, +30 days)"); onChanged(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="space-y-4" data-testid="crm-settings">
      <h2 className="font-display font-bold text-lg">CRM Settings</h2>

      <div className="rounded-2xl border border-border bg-background p-5 space-y-3" data-testid="crm-entitlement-card">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <p className="font-bold text-sm flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-emerald-600" /> Subscription</p>
          <span className="px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 text-[10px] font-extrabold uppercase tracking-wide">Active{ent?.test ? " · Test" : ""}</span>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm">
          <div><p className="text-[10px] uppercase tracking-widest font-extrabold text-muted-foreground">Plan</p><p className="font-bold">₹{ent?.price_monthly ?? 500}/month</p></div>
          <div><p className="text-[10px] uppercase tracking-widest font-extrabold text-muted-foreground">Activated</p><p className="font-bold">{ent?.activated_at ? fmtDateTime(ent.activated_at) : "—"}</p></div>
          <div><p className="text-[10px] uppercase tracking-widest font-extrabold text-muted-foreground">Renews / Expires</p><p className="font-bold">{ent?.expires_at ? fmtDateTime(ent.expires_at) : "—"}</p></div>
        </div>
        <button onClick={renew} disabled={busy} data-testid="crm-renew-test"
          className="h-10 px-5 rounded-xl border border-border text-xs font-extrabold flex items-center gap-1.5 hover:bg-muted disabled:opacity-60">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <RefreshCw className="h-3.5 w-3.5" />} Extend Test Period (+30 days)
        </button>
        <p className="text-[11px] text-muted-foreground">Real payment activation (₹500/month) is being wired to the platform billing system. CRM data is never deleted on expiry.</p>
      </div>

      <div className="rounded-2xl border border-border bg-background p-5 space-y-2">
        <p className="font-bold text-sm flex items-center gap-2"><Sparkles className="h-4 w-4 text-emerald-600" /> What's included</p>
        <div className="grid sm:grid-cols-2 gap-1.5 text-sm">
          {["Unlimited leads, contacts & deals", "Custom sales pipelines with stages & colors",
            "Form builder with public share links & QR", "CSV / Excel import with duplicate detection",
            "Facebook Lead Ads auto-sync (official Meta APIs)", "Follow-ups, reminders & activity timeline",
            "Sales reports & conversion analytics", "Full tenant isolation & mobile responsive"].map((f) => (
            <p key={f} className="flex items-center gap-2"><CheckCircle2 className="h-3.5 w-3.5 text-emerald-600 shrink-0" /> {f}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
